module.exports = __webpack_public_path__ + "img/fengmian1.26f612d7.png";